import {
  Flex,
  Stack,
  StackDirection,
  useBreakpointValue,
} from "@chakra-ui/react";

import { mobileStyleBreakpoint } from "util/styleHelpers";
import {
  ModeSelect,
  SalesTermsSelect,
  ShipFromSelect,
  ShipToSelect,
} from "./requestContractSelects";

const LINE_ITEM_STACK_DIRECTION = mobileStyleBreakpoint<StackDirection>(
  "column",
  "row"
);
const LINE_ITEM_PADDING_X = mobileStyleBreakpoint(2, 4);
const LINE_ITEM_PADDING_Y = mobileStyleBreakpoint(4, 3);

const ContractLineItem = ({ index }: { index: number }) => {
  const direction = useBreakpointValue(LINE_ITEM_STACK_DIRECTION, {
    ssr: false,
  });
  return (
    <Stack
      _odd={{ bgColor: "grey.50" }}
      _even={{ bgColor: "unset" }}
      px={LINE_ITEM_PADDING_X}
      py={LINE_ITEM_PADDING_Y}
      direction={direction}
      spacing={4}
    >
      <Flex flex={1} data-testid={`shipFrom-select-${index}`}>
        <ShipFromSelect id={`lineItems.${index}.shipFrom`} />
      </Flex>
      <Flex flex={1} data-testid={`shipTo-select-${index}`}>
        <ShipToSelect id={`lineItems.${index}.shipTo`} />
      </Flex>
      <Flex flex={1} data-testid={`salesTerms-select-${index}`}>
        <SalesTermsSelect id={`lineItems.${index}.salesTerms`} />
      </Flex>
      <Flex flex={1} data-testid={`mode-select-${index}`}>
        <ModeSelect id={`lineItems.${index}.mode`} />
      </Flex>
    </Stack>
  );
};
export default ContractLineItem;
